import { Input, Form, Row, Space, Col } from 'antd';
import { HolderOutlined, MinusCircleOutlined } from '@ant-design/icons';
import { Draggable } from 'react-beautiful-dnd';

interface ScheduleFormListItemProps {
  quote: any;
  index: number;
  remove: (index: number | number[]) => void;
}

export function ScheduleFormListItem({
  quote,
  index,
  remove,
}: ScheduleFormListItemProps) {
  // console.log(quote);
  return (
    <Draggable draggableId={quote.fieldKey.toString()} index={index}>
      {(provided) => (
        <Row
          justify={'center'}
          ref={provided.innerRef}
          {...provided.draggableProps}
        >
          <Col span={8}>
            <Space
              style={{
                display: 'flex',
              }}
              align="baseline"
            >
              {/* <div style={{ border: '1px solid grey', marginBottom: '15px' }}> */}
              {/* <span {...provided.dragHandleProps}>drag me here</span>
            <br />
            <span {...provided.dragHandleProps}>{quote.name}</span> */}
              <span {...provided.dragHandleProps}>
                <HolderOutlined rev={undefined} />
              </span>

              <Form.Item
                name="name"
                {...quote}
                rules={[
                  {
                    required: true,
                    message: '공정명을 입력하세요',
                  },
                ]}
              >
                <Input placeholder="예) 철거공사" style={{ width: '200px' }} />
              </Form.Item>
              <MinusCircleOutlined
                className="dynamic-delete-button"
                onClick={() => remove(quote.name)}
                rev={undefined}
              />

              {/* </div> */}
            </Space>
          </Col>
        </Row>
      )}
    </Draggable>
  );
}
